import React, { useState, useEffect } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import { useDispatch } from "react-redux";
import {
  getAllgovernoratesService,
  updateAreaService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const EditAreaModal = ({ isOpen, onClose, onConfirm, area, language }) => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");

  // تعيين القيمة الأولية عند فتح الـ modal أو تغيير المنطقة
  useEffect(() => {
    if (isOpen && area) {
      setName(area.name || "");
    }
  }, [isOpen, area]);

  if (!isOpen || !area) return null;

  const translations = {
    en: {
      editArea: "Edit Area",
      areaName: "Area Name",
      enterName: "Enter area name",
      forGovernorate: "For Governorate",
      cancel: "Cancel",
      update: "Update",
    },
    ar: {
      editArea: "تعديل المنطقة",
      areaName: "اسم المنطقة",
      enterName: "أدخل اسم المنطقة",
      forGovernorate: "للمحافظة",
      cancel: "إلغاء",
      update: "تحديث",
    },
  };

  const t = translations[language];

  const handleSubmit = () => {
    if (name.trim()) {
      dispatch(
        updateAreaService({
          id: area?.id,
          formData: { name: name.trim(), governorate_id: area?.governorate_id },
        })
      ).then((response) => {
        if (response.payload.status == 200) {
          setName("");
          onClose();
          toast("تم التعديل بنجاح");
          dispatch(getAllgovernoratesService());
        }
      });
    }
  };

  const handleClose = () => {
    setName("");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4 gap-2">
            <div className="p-2 rounded-full bg-[#b1903c]">
              <Icon
                name="Edit" // تغيير الأيقونة إلى Edit
                size={24}
                className="text-white"
              />
            </div>
            <h3 className="ml-3 text-lg font-semibold text-gray-900">
              {t.editArea}
            </h3>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">
              {t.forGovernorate}:{" "}
              <span className="font-medium">
                {area.governorate?.name || "N/A"}
              </span>{" "}
              {/* افترض أن area تحتوي على governorate */}
            </p>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.areaName}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t.enterName}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none"
            />
          </div>

          {/* Actions */}
          <div className="flex space-x-3 gap-4">
            <Button
              onClick={handleSubmit}
              className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              {t.update}
            </Button>
            <button
              onClick={handleClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              {t.cancel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAreaModal;
